import 'regenerator-runtime/runtime';

export * from './actions';

import _i18nextSaga from './saga';

export const i18nextSaga = _i18nextSaga;



// WEBPACK FOOTER //
// ./src/index.ts